import { Children, FunctionComponent } from 'react'
import Menu from '@material-ui/core/Menu'
import { useCurrentTarget } from 'hooks/use-current-target/useCurrentTarget'
import { MenuItem, IconButton, Box, Badge } from '@material-ui/core'
import styled from 'styled-components/macro'
import { ActionContextMenuItem } from 'components/core/actions-menu/ActionContextMenu'

interface AdminDropDownProps {
  title?: string
  icon?: any
  menuItems?: ActionContextMenuItem[]
  showCounterBadge?: boolean
  counterValue?: number
}

const MainMenu = styled(Menu)`
  border-radius: 3px !important;
  width: 15em !important;
  top: 0em !important;
  left: 1em !important;
`
const PrimaryMenuItem = styled(MenuItem)<{ first?: boolean; last?: boolean }>`
  min-height: 0em !important;
`
export const AdminDropDown: FunctionComponent<AdminDropDownProps> = ({
  showCounterBadge,
  counterValue,
  icon,
  children
}) => {
  const { anchorEl, handleCustomEventClick, handleReset } = useCurrentTarget()
  return (
    <Box>
      <IconButton onClick={e => handleCustomEventClick(e)} color="primary">
        {!showCounterBadge && icon}
        {showCounterBadge && (
          <Badge badgeContent={counterValue} variant="standard" color="primary">
            {icon}
          </Badge>
        )}
      </IconButton>
      <MainMenu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        onClose={handleReset}
        keepMounted
      >
        {Children.map(children, (x, i) => {
          return x === null ? null : (
            <PrimaryMenuItem onClick={handleReset} key={i}>
              {x}
            </PrimaryMenuItem>
          )
        })}
      </MainMenu>
    </Box>
  )
}
